"use client";

import useToggleState from "../hooks/use-toggle-state";
import { createContext, useContext } from "react";

interface MobileMenuContext {
  state: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const MobileMenuContext = createContext<MobileMenuContext | null>(null);

export const MobileMenuProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { state, close, open, toggle } = useToggleState();

  return (
    <MobileMenuContext.Provider
      value={{
        state,
        close,
        open,
        toggle,
      }}
    >
      {children}
    </MobileMenuContext.Provider>
  );
};

export const useMobileMenu = () => {
  const context = useContext(MobileMenuContext);

  if (context === null) {
    throw new Error(
      "useCartDropdown must be used within a CartDropdownProvider"
    );
  }

  return context;
};
